const responsiveNav = require('../modules/responsive-nav.js');

// Init responsive nav
const customToggle = document.getElementById('nav-toggle');

responsiveNav('.nav-collapse', {

    customToggle: '#nav-toggle',
    enableFocus: true,
    enableDropdown: true,
    openDropdown: '<span class="sr-only">Open sub menu</span>',
    closeDropdown: '<span class="sr-only">Close sub menu</span>',
    // Remove the Menu Icon before enabling the open and close function.
    // open: function () {
    //  customToggle.innerHTML = 'Close Menu';
    // },
    // close: function () {
    //  customToggle.innerHTML = 'Open Menu';
    // },
    resizeMobile() {

        customToggle.setAttribute('aria-controls', 'nav');

    },
    resizeDesktop() {

        customToggle.removeAttribute('aria-controls');

    },

});
